import React from 'react';
import { Typography } from 'antd';

import { useExperimentContext } from '../../contexts/experiment-context';
import { Experiment as DomainExperiment } from '../../domain';
import { ExperimentModel } from '@/common/ExperimentModel';
import { Experiment as PlannerExperiment } from '@/lib/PlannerDTOs';
import SectionCollapse from '@/pages/ExperimentFormV2/common/SectionCollapse';
import ExperimentOverlap from '@/pages/ExperimentPageV2/common/ExperimentOverlap';
import OverlapSummary from '@/pages/ExperimentPageV2/common/OverlapSummary';

/**
 * Converts domain Experiment to PlannerExperiment format.
 * Only converts fields needed by ExperimentModel and overlap components.
 */
export function toPlannerExperiment(
  experiment: DomainExperiment | null,
): PlannerExperiment | null {
  if (!experiment) return null;

  return {
    ...experiment,
    startTime: experiment.startTime?.unix(),
    endTime: experiment.endTime?.unix(),
  } as PlannerExperiment;
}

function ExperimentDetailOverlap() {
  const experimentContext = useExperimentContext();
  const { experiment } = experimentContext;
  const plannerExperiment = toPlannerExperiment(experiment);
  const model = new ExperimentModel(plannerExperiment);

  const renderOverlap = () => {
    if (model.isOverlap()) {
      return <OverlapSummary experiment={plannerExperiment} />;
    }

    if (model.isUsingXScheduler()) {
      return <ExperimentOverlap experiment={plannerExperiment} />;
    }

    return (
      <div style={{ padding: '0 32px' }}>
        <SectionCollapse defaultOpen title="Overlapping Experiments">
          <Typography.Text>
            There are no overlaps with this experiment.
          </Typography.Text>
        </SectionCollapse>
      </div>
    );
  };
  return <div style={{ margin: '16px 0px 64px' }}>{renderOverlap()}</div>;
}

export default ExperimentDetailOverlap;
